// extracted by mini-css-extract-plugin
export default {"toolbar_light":"Header_toolbar_light__mV9sm","toolbar_dark":"Header_toolbar_dark__YRhhQ"};